import api from 'core/api';
import { call, put } from 'redux-saga/effects';

export const channelsEventsRegistrationsModule = 'channelsEventsRegistrations';

const loadingStates = {
  start: { loading: true },
  error: { loading: false },
  success: { loading: false },
};

const loadingFormStates = {
  start: { loadingForm: true },
  error: { loadingForm: false },
  success: { loadingForm: false },
};

const actions = {
  getRegistrations: {
    module: channelsEventsRegistrationsModule,
    name: 'getRegistrations',
    api: (params) =>
      api.get(
        `/channels/${params?.channelId}/channels_events/${params?.channelsEventId}/channels_events_registrations`,
        { params },
      ),
    *sagas(Creators, { params, options }) {
      try {
        const resp = yield call(actions.getRegistrations.api, params);
        yield put(Creators.getRegistrationsSuccess());
        if (options.onSuccess) {
          options.onSuccess(resp.data, resp.pagination);
        }
      } catch (error) {
        if (options.onError) {
          options.onError(error);
        }
        yield put(Creators.getRegistrationsError());
      }
    },
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingStates,
  },
  create: {
    module: channelsEventsRegistrationsModule,
    name: 'create',
    api: (data) =>
      api.post(
        `/channels/${data?.channelId}/channels_events/${data?.channelsEventId}/channels_events_registrations`,
        data,
      ),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingFormStates,
  },
  destroy: {
    module: channelsEventsRegistrationsModule,
    name: 'destroy',
    api: (params) =>
      api.delete(
        `/channels/${params?.channelId}/channels_events/${params?.channelsEventId}/channels_events_registrations/${params?.id}`,
        { params },
      ),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingFormStates,
  },
};

const channelsEventsRegistrationsActionsAndStates = {
  actions,
  state: {
    error: null,
    loadingForm: false,
  },
};

export default channelsEventsRegistrationsActionsAndStates;
